import TextFade from "../../components/CustomTexts/TextFade";
//import CallToActionSection from "../../components/Others/CallToActionSection";

import heroImage from "../../assets/Sahel-2024-Food-Changemakers-Conference/4.jpg";

// MIXED WITH MP4
import sandDredgingImage from "../../assets/Sahel-2024-Food-Changemakers-Conference/1.mp4";

import missionVid from "../../assets/holycross/holy1.mp4";
import TextEffect from "../../components/CustomTexts/TextEffect";

// MIXED
import bgIMG from "../../assets/Sahel-2024-Food-Changemakers-Conference/2.mp4";

// CHANGED TO SAHEL JPGS
import trainingImg from "../../assets/Sahel-2024-Food-Changemakers-Conference/1.jpg";
import chysonImg from "../../assets/Sahel-2024-Food-Changemakers-Conference/2.jpg";
import farmImg from "../../assets/Sahel-2024-Food-Changemakers-Conference/3.jpg";

import womenImg from "../../assets/Sahel-2024-Food-Changemakers-Conference/4.jpg";
import women1Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/5.jpg";
import women2Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/6.jpg";
import women3Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/7.jpg";
import women4Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/1.jpg";
import women5Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/2.jpg";
import women6Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/3.jpg";
import women7Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/4.jpg";
import women8Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/5.jpg";

import stiImg from "../../assets/Sahel-2024-Food-Changemakers-Conference/6.jpg";
import sti1Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/7.jpg";
import sti2Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/1.jpg";
import sti3Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/2.jpg";
import sti4Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/3.jpg";

import consultancyImg from "../../assets/Sahel-2024-Food-Changemakers-Conference/4.jpg";
import consultancy2Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/5.jpg";
import consultancy3Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/6.jpg";
import consultancy4Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/7.jpg";
import consultancy5Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/1.jpg";
import consultancy6Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/2.jpg";

import sahelImg from "../../assets/Sahel-2024-Food-Changemakers-Conference/3.jpg";
import sahel1Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/4.jpg";
import sahel2Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/5.jpg";
import sahel3Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/6.jpg";

import sahel4Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/1.jpg";

// MIX MP4
import sahel5Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/1.mp4";

import sahel6Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/2.jpg";

// MIX MP4
import sahel7Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/2.mp4";

import sahel8Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/3.jpg";
import sahel9Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/5.jpg";
import sahel10Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/4.jpg";
import sahel11Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/7.jpg";
import sahel12Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/6.jpg";

import consultancy7Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/1.jpg";
import consultancy8Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/2.jpg";
import consultancy9Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/3.jpg";
import consultancy10Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/4.jpg";
import consultancy11Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/5.jpg";
import consultancy12Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/6.jpg";
import consultancy13Img from "../../assets/Sahel-2024-Food-Changemakers-Conference/7.jpg";

import consultancy14Img from "../../assets/holycross/holy2.mp4";
import consultancy15Img from "../../assets/holycross/holy3.mp4";
import consultancy16Img from "../../assets/holycross/holy4.mp4";
import consultancy17Img from "../../assets/holycross/holy5.mp4";
import consultancy18Img from "../../assets/holycross/holy.mp4";
//import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { useState } from "react";

const ImageModal = ({ image, caption, onClose }: { image: string, caption: string, onClose: () => void }) => (
  <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-lg shadow-lg max-w-3xl w-full overflow-hidden relative">
      <img src={image} alt={caption} className="w-full max-h-[80vh] object-contain" />
      <p className="text-center text-lg font-semibold text-dark py-4">{caption}</p>
      <button
        onClick={onClose}
        className="absolute top-2 right-2 text-white bg-black rounded-full p-2 hover:bg-gray-700"
      >
        ✕
      </button>
    </div>
  </div>
);

const ChangemakersTraining = () => {
  const [modal, setModal] = useState<{ img: string; caption: string } | null>(null);
  const [activeTab, setActiveTab] = useState("participation");

  const trainingGallery = [
  { img: heroImage, caption: "Holy Cross Training" },
  { img: consultancy7Img, caption: "Hands-On Workshop" },
  { img: consultancy14Img, caption: "Sustainable Agriculture" },
  { img: farmImg, caption: "Empowering Farmers" },
  { img: consultancy2Img, caption: "Knowledge Sharing" },
  { img: trainingImg, caption: "Personalized Mentorship" },
  { img: consultancy15Img, caption: "Training Session" },
  { img: sandDredgingImage, caption: "Field Experience" },
  { img: consultancy11Img, caption: "Practical Skills" },
  { img: consultancy5Img, caption: "Innovative Solutions" },
  { img: consultancy3Img, caption: "Community Engagement" },
  { img: sahelImg, caption: "Sahel 2023 Conference" },
  { img: consultancy10Img, caption: "Field Demonstration" },
  { img: consultancy9Img, caption: "Hands-On Learning" },
  { img: consultancy16Img, caption: "Empowering Farmers" },
  { img: consultancy4Img, caption: "Sustainable Practices" },
  { img: consultancy12Img, caption: "Community Impact" },
  { img: consultancy6Img, caption: "Agricultural Training" },
  { img: consultancy17Img, caption: "Agricultural Innovation" },
  { img: consultancy8Img, caption: "Empowering Youth" },
  { img: consultancy13Img, caption: "Agribusiness Development" },
  { img: consultancy18Img, caption: "Community Training" },
  { img: consultancyImg, caption: "Consultancy Session" },
  { img: chysonImg, caption: "Chyson Foods Collaboration" },
  { img: sahel1Img, caption: "Sahel 2024 Conference" },
  { img: sahel2Img, caption: "Networking Opportunities" },
  { img: sahel3Img, caption: "Industry Insights" },
  { img: sahel4Img, caption: "Panel Discussions" },
  { img: sahel5Img, caption: "Workshops & Seminars" },
  { img: sahel6Img, caption: "Exhibition Stalls" },
  { img: sahel7Img, caption: "Keynote Speakers" },
  { img: sahel8Img, caption: "Closing Ceremony" },
  { img: sahel9Img, caption: "Event Highlights" },
  { img: sahel10Img, caption: "Food Innovation" },
  { img: sahel11Img, caption: "Sustainable Solutions" },
  { img: sahel12Img, caption: "Agricultural Development" },
  {img: womenImg, caption: "2022 International Day for Rural Women"},
  {img: women1Img, caption: "2022 International Day for Rural Women"},
  {img: women2Img, caption: "2022 International Day for Rural Women"},
  { img: women3Img, caption: "2022 International"},
  { img: women4Img, caption: "2022 International"}, 
  { img: women5Img, caption: "2022 International"},
  { img : women6Img, caption: "2022 International"}, 
  { img : women7Img, caption: "2022 International"},
  { img : women8Img, caption: "2022 International"}, 
  { img: stiImg, caption: "STI Farmers Meeting" },
  { img: sti1Img, caption: "STI Value Chain" },
  { img: sti2Img, caption: "STI Training" },
  { img: sti3Img, caption: "STI Workshop" },
  { img: sti4Img, caption: "STI Leadership" }
  ];

  const tabContent: Record<string, JSX.Element> = {
    participation: (
      <div className="flex flex-col md:flex-row items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
    Sahel 2024 Food Changemakers 
                    </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
Simdozi International Limited is always in touch with her various partners and collaborators especially in showcasing what we are doing in Nigeria's food system. In 2024, Sahel Food Changemakers Conference to showcase our work in the OFSP value chain development.
 </p>
        </div>
        <div className="md:w-1/2">
          <img src={consultancy10Img} alt="Hands-On Workshops" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    )
  };

  return (
    <div className="about-container">
      {/* Hero Section */}
      <div
        className="relative h-[60vh] flex items-center justify-center text-white bg-cover bg-center z-0"
        style={{ backgroundImage: `url(${consultancy7Img})` }}
      >
        <div className="absolute inset-0 bg-black opacity-50 z-0" />
        <div className="z-10">
          <TextEffect text="Sahel 2024 Food Changemakers Conference" className="hero-title" />
        </div>
      </div>

      {/* Tabbed Pane Section */}
      <div className="px-4 sm:px-[6%] mt-20 mb-24 gap-6">
                <div className="flex flex-wrap justify-center mb-8 space-x-4">
          <button
            onClick={() => setActiveTab("participation")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "participation" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
        Sahel 2024 Food Changemakers Conference
            </button>
      </div>

        <div className="transition-all duration-500">{tabContent[activeTab]}</div>
      </div>


      {/* Overview Section */}
      <div className="relative">
        <div
          className="relative bg-green-500 text-white px-4 sm:px-[5%] py-20 bg-cover bg-center z-0"
          style={{ backgroundImage: `url(${bgIMG})` }}
        >
          <div className="absolute inset-0 bg-green-650 opacity-80 z-0" />
          <div className="relative z-10 flex md:flex-row flex-col justify-between items-center gap-16">
        <div className="md:w-[40%] w-full flex justify-center">
  <video
    src={missionVid}
    controls
    loop
    muted
    playsInline
    className="w-[80%] max-w-[450px] rounded-2xl shadow-lg"
  />
</div>

            <div className="md:w-[60%] w-full space-y-4">
              <TextFade animation="fade-down">
                <h1 className="text-[30px] md:text-[40px] font-bold text-white mb-4 leading-tight">
                  <TextEffect text4="THE CROP FARMING ROUND TABLE IS A FEDERAL GOVERNMENT AGENCY" />
                </h1>
              </TextFade>
              <p className="text-white text-[17px] md:text-[20px] leading-relaxed">
Itself collaborating with the private sector in improving agricultural output and outcomes. It was the first of its kind with the theme: From Seed to Shipment.
</p>
              <p className="text-white text-[17px] md:text-[20px] leading-relaxed">
Simdozi International Limited is always in touch with her various partners and collaborators especially in showcasing what we are doing in Nigeria's food system.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Gallery Section */}
      <div className="px-4 sm:px-[5%] mt-24 mb-20">
        <TextFade animation="fade-up">
          <h1 className="text-center text-[24px] md:text-[30px] font-bold text-dark mb-8">
            <TextEffect part4="Sahel 2024 Food Changemakers Conference Gallery" />
          </h1>
        </TextFade>

        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 1.5 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 }
          }}
          navigation
          autoplay={{ delay: 3000 }}
          loop
          modules={[Navigation, Autoplay]}
        >
          {trainingGallery.map(({ img, caption }, index) => (
  <SwiperSlide key={index}>
    <div
      className="relative w-full h-[260px] sm:h-[300px] rounded-xl overflow-hidden group cursor-pointer"
      onClick={() => setModal({ img, caption })}
    >
      {img.endsWith(".mp4") ? (
        <video
          src={img}
          controls
          loop
          muted
          playsInline
          className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
        />
      ) : (
        <img
          src={img}
          alt={caption}
          className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
        />
      )}

      <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition duration-300">
        <p className="text-white text-lg font-bold">{caption}</p>
      </div>
    </div>
  </SwiperSlide>
))}

        </Swiper>
      </div>

      {modal && <ImageModal image={modal.img} caption={modal.caption} onClose={() => setModal(null)} />}
    </div>
  );
};

export default ChangemakersTraining;
